module.exports = __webpack_public_path__ + "img/bg_baoxian@3x.bc3f2a0c.png";